/* eslint-disable */
<template>
  <section class="assess-page">
    <vue-basic-alert :duration="400" ref="alert" />

    <!-- Not logged in -->
    <div v-if="!user" class="login-prompt">
      <div class="login-card">
        <div class="login-icon">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
          </svg>
        </div>
        <h2>Authentication Required</h2>
        <p>Please sign in to view your payment history.</p>
        <router-link class="login-btn" to="/login">Sign In to Continue</router-link>
      </div>
    </div>

    <!-- Logged in -->
    <div v-else class="page-body">

      <!-- Page Header -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Assessment Tax | වරිපනම් බදු</p>
            <h1 class="page-title">Payment History</h1>
            <p class="page-subtitle">ගෙවීම් විස්තරය</p>
          </div>
        </div>
        <router-link to="/AssessmentTaxNewNew" class="back-btn" @click="scrollToTop()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>
          </svg>
          Back to Payment
        </router-link>
      </div>

      <!-- Table Card -->
      <div class="form-card">
        <div class="card-header">
          <div class="step-badge">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
            </svg>
          </div>
          <div>
            <h2 class="card-title">Transaction Records</h2>
            <p class="card-desc">{{ data.length }} record{{ data.length !== 1 ? 's' : '' }} found</p>
          </div>
        </div>

        <!-- Table -->
        <div class="table-wrap">
          <table class="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Invoice No.</th>
                <th>Ward</th>
                <th>Street</th>
                <th>Assessment No.</th>
                <th>Description</th>
                <th>Amount (Rs.)</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="paginatedData.length === 0">
                <td colspan="8" class="empty-row">No payment records found.</td>
              </tr>
              <tr v-for="(item, index) in paginatedData" :key="index">
                <td class="idx-cell">{{ (currentPage - 1) * itemsPerPage + index + 1 }}</td>
                <td class="invoice-cell">{{ item.tax_invoice_num }}</td>
                <td>{{ item.tax_ward }}</td>
                <td>{{ item.tax_street }}</td>
                <td>{{ item.tax_no }}</td>
                <td class="desc-cell">{{ item.tax_description }}</td>
                <td class="amount-cell">{{ item.tax_price }}</td>
                <td class="date-cell">{{ formatDate(item.tax_cur_date) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="pagination" v-if="totalPages > 1">
          <button class="page-btn" @click="prevPage($event)" :disabled="currentPage === 1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>
            </svg>
          </button>
          <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
          <button class="page-btn" @click="nextPage($event)" :disabled="currentPage === totalPages">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
            </svg>
          </button>
        </div>

      </div>
    </div>
  </section>
</template>


<script>
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import VueBasicAlert from 'vue-basic-alert';

export default {
  name: "AssessmentTax",
  components: { VueBasicAlert },
  data() {
    return {
      Nic: '', matchUser: undefined,
      currentDate: new Date(),
      itemsPerPage: 20,
      currentPage: 1,
      data: [],
    };
  },
  created() {
    this.getSessionData();
    this.fetchPaymentHistory();
  },
  computed: {
    ...mapState(["user"]),
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return Array.isArray(this.data) ? this.data.slice(start, start + this.itemsPerPage) : [];
    },
    totalPages() {
      return Math.ceil(this.data.length / this.itemsPerPage);
    },
  },
  methods: {
    ...mapMutations(["setUser"]),

    scrollToTop() { window.scrollTo(0, 0); },

    formatDate(givedate) {
      const date = new Date(givedate);
      return date.toISOString().split('T')[0];
    },

    async MatchUser(nic) {
      let data1 = await axios.get('/customersdata/' + nic);
      this.matchUser = data1.data;
    },

    async getSessionData() {
      const data2 = JSON.parse(sessionStorage.getItem('Userdata'));
      if (data2) { this.Nic = data2.Unic; }
      await this.MatchUser(this.Nic);
      this.setUser(this.matchUser);
    },

    async fetchPaymentHistory() {
      try {
        let response = await axios.get('/assessmenttax/' + this.user.cus_nic);
        this.data = response.data;
      } catch (error) {
        console.error('Error fetching payment history:', error);
      }
    },

    nextPage(event) {
      event.preventDefault();
      if (this.currentPage < this.totalPages) this.currentPage++;
    },

    prevPage(event) {
      event.preventDefault();
      if (this.currentPage > 1) this.currentPage--;
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,300;0,9..40,400;0,9..40,500;0,9..40,600&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

/* ── Page ── */
.assess-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}
.page-body { max-width: 1100px; margin: 0 auto; width: 100%; }

/* ── Login Prompt ── */
.login-prompt { display: flex; align-items: center; justify-content: center; min-height: 80vh; }
.login-card {
  background: #fff; border-radius: 1.4rem; padding: 4rem 3.5rem;
  text-align: center; max-width: 420px; width: 100%;
  box-shadow: 0 8px 30px rgba(100,50,30,0.10);
}
.login-icon {
  width: 6rem; height: 6rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-radius: 50%; display: flex; align-items: center; justify-content: center;
  margin: 0 auto 1.8rem;
}
.login-icon svg { width: 2.8rem; height: 2.8rem; stroke: #fff; }
.login-card h2 { font-family: 'DM Serif Display', serif; font-size: 2.2rem; color: #1c0f0a; margin: 0 0 0.8rem; }
.login-card p  { font-size: 1.45rem; color: #7a6258; margin: 0 0 2rem; }
.login-btn {
  display: inline-block; padding: 1.1rem 2.8rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border-radius: 0.8rem; font-size: 1.5rem; font-weight: 600;
  text-decoration: none; transition: all 0.2s;
}
.login-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(124,45,18,0.35); }

/* ── Page Header ── */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2.8rem; gap: 1.5rem; flex-wrap: wrap;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.page-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0; }

.back-btn {
  display: inline-flex; align-items: center; gap: 0.6rem;
  padding: 0.9rem 1.8rem; border: 1.5px solid #c2440a;
  color: #c2440a; background: #fff; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.4rem; font-weight: 500;
  text-decoration: none; cursor: pointer; transition: all 0.2s; white-space: nowrap;
}
.back-btn svg { width: 1.7rem; height: 1.7rem; }
.back-btn:hover { background: #c2440a; color: #fff; }

/* ── Card ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2.4rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
}

.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 2rem; padding-bottom: 1.5rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 4rem; height: 4rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.9rem; height: 1.9rem; stroke: #fff; }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.8rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.card-desc { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* ── Table ── */
.table-wrap {
  overflow-x: auto;
  border: 1px solid #e5ddd5;
  border-radius: 0.8rem;
  margin-bottom: 2rem;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 1.3rem;
}

.data-table thead tr {
  background: #f0ebe3;
}

.data-table th {
  padding: 1.1rem 1.2rem;
  text-align: left;
  font-size: 1.15rem;
  font-weight: 600;
  color: #4a3028;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #e5ddd5;
  white-space: nowrap;
}

.data-table td {
  padding: 1rem 1.2rem;
  color: #1c0f0a;
  border-bottom: 1px solid #f0ebe3;
  vertical-align: middle;
}

.data-table tbody tr:last-child td { border-bottom: none; }

.data-table tbody tr:hover { background: #fdf9f6; }

.data-table tbody tr:nth-child(even) { background: #faf8f6; }
.data-table tbody tr:nth-child(even):hover { background: #fdf9f6; }

.idx-cell    { color: #9a8070; font-size: 1.2rem; text-align: center; width: 3rem; }
.invoice-cell { font-weight: 600; color: #7c2d12; }
.amount-cell { font-weight: 700; color: #1c0f0a; text-align: right; font-variant-numeric: tabular-nums; }
.date-cell   { color: #4a3028; white-space: nowrap; }
.desc-cell   { max-width: 20rem; }

.empty-row {
  text-align: center;
  color: #9a8070;
  font-size: 1.4rem;
  padding: 3rem !important;
}

/* ── Pagination ── */
.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.2rem;
}

.page-btn {
  display: flex; align-items: center; justify-content: center;
  width: 3.6rem; height: 3.6rem;
  border: 1.5px solid #e5ddd5;
  background: #fff; border-radius: 0.6rem;
  cursor: pointer; transition: all 0.2s;
  color: #4a3028;
}
.page-btn svg { width: 1.6rem; height: 1.6rem; stroke: currentColor; }
.page-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  border-color: transparent;
  color: #fff;
}
.page-btn:disabled { opacity: 0.35; cursor: not-allowed; }

.page-info { font-size: 1.35rem; color: #4a3028; font-weight: 500; }

/* ── Responsive ── */
@media (max-width: 768px) {
  .assess-page { padding: 1.5rem 1rem 3rem; }
  .page-title { font-size: 2rem; }
  .page-header { flex-direction: column; }
  .form-card { padding: 1.6rem; }
  .data-table th, .data-table td { padding: 0.8rem; font-size: 1.2rem; }
}
</style>